module.exports = __webpack_public_path__ + "img/hz_36.a29b2c61.jpg";